import { useMemo } from 'react'
import useStyles from './StarsRating.styled'
import { useSectionId } from '../SectionItem'

export const useStarsRating = props => {
	const classes = useStyles(props)
	const sectionId = useSectionId()

	const { rating, itemKey } = props

	const value = _.clamp(rating || 0, 0, 5)

	const starsRate = useMemo(() => {
		return Array.from({ length: 5 }, (v, index) => {
			return {
				key: `key-${sectionId}-${itemKey}-${index}`,
				percentage: _.clamp(value - index, 0, 1) * 100,
			}
		})
	}, [value, sectionId, itemKey])

	return [{ classes, starsRate, sectionId }]
}
